import { render, staticRenderFns } from "./RoleTree.vue?vue&type=template&id=63abe90a&scoped=true"
import script from "./RoleTree.vue?vue&type=script&lang=ts"
export * from "./RoleTree.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63abe90a",
  null
  
)

export default component.exports